import styled from 'styled-components'
import { Button } from "../../../ui/button"
import { Input } from "../../../ui/input"

const UploadImage = () => {

    return(
        <MainContainer>
            <Title>
                上傳封面圖片
            </Title>
            <Input id="picture" type="file" />
            <ButtonGroup>
                <Button>上傳</Button>
                <Button variant="outline" >取消</Button>
            </ButtonGroup>
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default UploadImage